import { Dispatch, SetStateAction } from 'react';
import { Divider, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import CustomModal from '../../../../components/modal/CustomModal';
import { ReactComponent as ClipboardCheckIcon } from '../../../../assets/icons/layout-icons/ClipboardCheckIcon.svg';
import { secondaryBlue } from '../../../../utils/color';
import CustomButton from '../../../../components/button/CustomButton';
import BaseInputLabel from '../../../../components/custom-inputs/BaseInputLabel';

type CaseStudyReviewModalProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
};

const CaseStudyReviewModal = ({ setIsOpen, isOpen }: CaseStudyReviewModalProps) => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();

  return (
    <CustomModal open={isOpen} onClose={() => setIsOpen(false)} width="45%" disablePortal>
      <Stack spacing={3}>
        <Stack spacing={2} direction="row" alignItems="center">
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              bgcolor: '#E5E8FF',
              width: 'fit-content',
              height: 'fit-content',
              borderRadius: '6px',
              p: 2,
            }}
          >
            <ClipboardCheckIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />
          </Stack>
          <Typography variant="heading3" color="primaryDark.600">
            {t('caseStudies.modals.review.title')}
          </Typography>
        </Stack>
        <Divider />
        <Typography color="primaryDark.500" pb={2}>
          {t('caseStudies.modals.review.text')}
        </Typography>
        <Divider />
        <Stack sx={{ justifyContent: 'end' }} spacing={2} direction="row">
          <CustomButton variant="secondary" onClick={() => setIsOpen(false)}>
            {t('common.cancel')}
          </CustomButton>
          <CustomButton variant="primary" type="submit">
            {t('common.submit')}
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default CaseStudyReviewModal;
